<template>
    <div class="quizier-module-container">
        <div class="module-wrapper" v-if="!isPostLocked">
            <div class="block-title" v-if="has_title || block_type">
                <div class="h-numb number-list" v-if="(block_type == 'list' || block_type == 'rank') && list_number"
                    :style="[bg_color ? { 'background-color': bg_color } : '']" :class="[block_class]">
                    {{ list_number }}
                </div>
                <div class="bulet bullet-list" v-if="block_type == 'bullet'"
                    :style="[bg_color ? { 'background-color': bg_color } : '']"></div>
                <h3 class="title-txt" v-if="has_title">{{ has_title }}</h3>
                <div class="votebtn-cont rank-list" v-if="block_type == 'rank'">
                    <a @click="vote_block" class="btn-down"
                        :class="[has_voted() ? 'voted' : '', downvoted() ? 'has-votes' : '']" v-if="vote_down"
                        data-action="down">
                        <div class="loader"></div>
                        <div class="txt-cont">
                            <span v-html="svg('caret-down')"></span>
                            <div class="numb-cont">
                                <div class="numb">{{ down_votes }}</div>
                                <div class="btxt">{{ $tc('i18n.votes', down_votes) }}</div>
                            </div>
                        </div>
                    </a>
                    <a @click="vote_block" class="btn-up"
                        :class="[has_voted() ? 'voted' : '', upvoted() ? 'has-votes' : '']" data-action="up">
                        <div class="loader"></div>
                        <div class="txt-cont">
                            <span v-html="svg('caret-up')"></span>
                            <div class="numb-cont">
                                <div class="numb">{{ up_votes }}</div>
                                <div class="btxt">{{ $tc('i18n.votes', up_votes) }}</div>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="clearfix"></div>
            </div>
            <component :is="componentName" :index="index" :store="store" />
            <div class="field description module-description" v-if="has_description" v-html="has_description" />
        </div>
        <div v-else-if="isPostLocked" class="block-is-locked">
            <div class="locked-wrapper">
                <login v-if="!isLoggedin" />
                <diamonds unlock-type="block" :post-id="me.index" class="unlock-with-diamonds"
                    v-if="isLoggedin && blockLock === 'diamond'" @unlocked="unlockPost" />
                <follow unlock-type="block" :post-id="me.index" class="unlock-by-follow"
                    v-if="isLoggedin && blockLock === 'follow'" @following="followAuthorPost" />
            </div>
        </div>
        <div class="in-article-advert mt-2" v-if="has_adsense(index)">
            <InArticleAdsense :data-ad-client="$variables.adsense_publisher_id" :data-ad-slot="slot_id" />
        </div>
    </div>
</template>

<script>
import axios from "axios"
import mixinComponent from '../mixins'
import Login from './Lock/Login'
import Diamonds from './Lock/Diamonds'
import Follow from './Lock/Follow'

export default {
    props: ['name', 'index', 'displayLanguage'],
    mixins: [mixinComponent],
    components: {
        Login,
        Diamonds,
        Follow,
    },
    data() {
        return {
            text_class: 'text-color-light',
            default_vote_down: false,
        }
    },
    computed: {
        isPostLocked() {
            if (!this.canLock) {
                return false;
            }

            if (this.blockLock == 'diamond') {
                return !this.isDiamondUnlocked
            }

            if (this.blockLock == 'follow') {
                return !this.isFollowerLocked
            }

            return false;
        },
        canLock() {
            return this.$variables.can_lock_blocks
        },
        isDiamondUnlocked() {
            return this.has_block('is_block_unlocked', false)
        },
        isFollowerLocked() {
            return this.has_setting('is_user_following_author', false)
        },
        blockLock() {
            return this.has('block_lock', null)
        },
        isLoggedin() {
            return this.$variables.user
        },
        componentName: function () {
            if ((this.name != 'personalityquiz' || this.name != 'trivia') && this.has('quiz_layout', 0) == 1) {
                return `${this.name}-list`
            }

            return this.name
        },
        list_number: function () {
            return this.has('counter', false)
        },
        has_title: function () {
            return this.has('title', false)
        },
        has_description: function () {
            return this.has('description')
        },
        block_type: function () {
            return this.has('block_type', false)
        },
        bg_color: function () {
            return this.has('block_colors.hex', false)
        },
        block_class: function () {
            return this.has('block_text_class', this.text_class)
        },
        vote_down: function () {
            return this.has('vote_down', this.default_vote_down)
        },
        up_votes: function () {
            return this.has_block('counts.up')
        },
        down_votes: function () {
            return this.has_block('counts.down')
        }
    },
    methods: {
        followAuthorPost: function (state) {
            this.store.state.settings.is_user_following_author = state
        },
        unlockPost: function (state) {
            this._updateMe(is_post_unlocked, state)
        },
        has_voted: function () {
            return this.has_block('has_voted', false)
        },
        upvoted: function () {
            return this.has_block('has_upvoted', false)
        },
        downvoted: function () {
            return this.has_block('has_downvoted', false)
        },
        vote_block: function (e) {
            if (this.has_voted()) return

            let curTarget = e.currentTarget
            let $this = curTarget.dataset
            const url = this.$variables.ranking_url
            var action = {}
            action['action'] = $this.action
            action['index'] = this.has_block('index')
            action['post_id'] = this.post_id()
            action['url'] = url

            if (action['action'] == '' || !url) {
                Quizier.sweetError(this.$t('i18n.somethingWentWrong'))
                return false
            }

            axios.post(url, action).then(res => {
                if (res.data.reload) {
                    location.reload()
                }
                if (res.data.success) {
                    this._updateMe('has_voted', true)
                    this._updateMe('counts', res.data.action.counts)
                    // this.sortUpdate()
                }
            }).catch(err => {
                console.log('err from modcont', err)
                Quizier.sweetError(err.response.data.message)
                return false
            })
        },
    }
}
</script>
